// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBpOq-NFe-HqCJWw5d6AptbTFFsv7bXDYw",
  authDomain: "ksite-977c8.firebaseapp.com",
  databaseURL: "https://ksite-977c8-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "ksite-977c8",
  storageBucket: "ksite-977c8.firebasestorage.app",
  messagingSenderId: "108646387400",
  appId: "1:108646387400:web:151da4a220cdf5bbcc1ffd"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Realtime Database
export const database = getDatabase(app);

export default app;
